/* SNEED 3.0 item 23: product page upgrade behaviour. New file. */
(function () {
  'use strict';

  /* 1. Phone: keep the chat bubble off the gallery while the photos are on screen. */
  function galleryWatch() {
    var g = document.querySelector('media-gallery');
    if (!g || !('IntersectionObserver' in window)) return;
    var mq = window.matchMedia('(max-width: 749px)');
    var io = new IntersectionObserver(function (entries) {
      var on = entries[0].isIntersecting && mq.matches;
      document.documentElement.classList.toggle('fb-v3-gallery-in-view', on);
    }, { threshold: 0.05 });
    io.observe(g);
  }

  /* 2. Daily deal clock tier (uses the shared [data-fb-cd] ticker for the digits). */
  function dealTier() {
    var els = document.querySelectorAll('.fb-v3-deal');
    if (!els.length) return;
    function set() {
      var DAY = 86400000, OFF = 36000000, a = Date.now() + OFF;
      var t = Math.floor(a / DAY) * DAY + 18 * 3600000;
      if (a >= t) t += DAY;
      var r = Math.floor((t - a) / 1000);
      for (var i = 0; i < els.length; i++) els[i].setAttribute('data-urgency', r > 21600 ? '24h' : '6h');
    }
    set();
    setInterval(set, 60000);
  }

  /* 3. Track our releases: show the link only when that franchise has an upcoming event. */
  var KEYS = { 'one-piece': ['one piece'], 'pokemon': ['pokemon', 'pokémon'], 'dragon-ball': ['dragon ball'] };
  var LABELS = { 'one-piece': 'One Piece', 'pokemon': 'Pokemon', 'dragon-ball': 'Dragon Ball' };

  function goldCoastToday() {
    var d = new Date(Date.now() + 36000000);
    return d.toISOString().slice(0, 10);
  }

  function readCache() {
    try {
      var raw = sessionStorage.getItem('fbEvCal1');
      if (!raw) return null;
      var o = JSON.parse(raw);
      if (Date.now() - o.t > 1800000) return null;
      return o.events;
    } catch (e) { return null; }
  }
  function writeCache(events) {
    try { sessionStorage.setItem('fbEvCal1', JSON.stringify({ t: Date.now(), events: events })); } catch (e) {}
  }

  function getEvents(cb) {
    var c = readCache();
    if (c) return cb(c);
    fetch('/pages/events', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var m = html.match(/<script type="application\/json" data-fcal-data[^>]*>([\s\S]*?)<\/script>/);
        if (!m) return cb(null);
        var data = JSON.parse(m[1]);
        var ev = (data.events || []).map(function (e) { return { d: e.date, c: String(e.category || '').toLowerCase() }; });
        writeCache(ev);
        cb(ev);
      })
      .catch(function () { cb(null); });
  }

  function eventLinks() {
    var slots = document.querySelectorAll('[data-fb-evl]');
    if (!slots.length) return;
    getEvents(function (events) {
      if (!events) return;
      var today = goldCoastToday();
      for (var i = 0; i < slots.length; i++) {
        var key = slots[i].getAttribute('data-fb-evl');
        var words = KEYS[key];
        if (!words) continue;
        var has = events.some(function (e) {
          return e.d >= today && words.some(function (w) { return e.c.indexOf(w) !== -1; });
        });
        if (has) {
          var a = document.createElement('a');
          a.href = '/pages/events?show=' + key;
          a.textContent = 'Track our ' + LABELS[key] + ' releases';
          slots[i].appendChild(a);
        }
      }
    });
  }

  function boot() {
    galleryWatch();
    dealTier();
    eventLinks();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();